import API from "./const";
import { toast } from "components/toast/toast";
import useVahakHttpClient from "../hooks/useVahakHttpClient";
import { ClientHookOptions, useVahakMutationQuery, useVahakQuery } from "../hooks/useVahakQueryClient";
import { QueryNames } from "./hooks/queryNames";
import { getAuthHeader } from "./utils/getAuthHeader";
import { generateQueryString } from "../methods/generateQueryString";
async function searchByPhone(customerMobile: string) {
    try {
        const call = await fetch(
            new Request(`${API.CUSTOMER_PROFILE_DETIALS_BY_PHONE}p_n=${customerMobile}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    key: process.env.NEXT_PUBLC_REACT_APP_KEY || "",
                    ...getAuthHeader()
                }
            })
        );

        if (call.status === 200) {
            const response = await call.json();
            return response.data;
        }
        if (!call.ok) {
            throw await call.json();
        }
    } catch (error) {
        /**
         * Uncomment the toast, after the backend stopsthrowing error for normal user roles.
         */
        // toast.error("An error occured, please try again after sometime", DefaultToastOptions);
    }
}

async function getUserRoles(userId: string | number) {
    try {
        const call = await fetch(
            new Request(`${API.GET_USER_ROLES}id=${userId}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            })
        );

        if (call.status === 200) {
            const response = await call.json();
            return response.data;
        }
        if (!call.ok) {
            throw await call.json();
        }
    } catch (error) {
        toast.error("An error occured, please try again after sometime");
    }
}

export const AuthServiceAdminConsole = {
    searchByPhone,
    getUserRoles
};

export interface SearchCompanyByPhoneNumberParams {
    phoneNumber: string;
}

export interface SearchCompanyByPhoneNumberQuery {
    p_n: string;
}

export interface SearchCompanyByPhoneNumberResponse {
    data: { id: number; phone_number: string; name: string; subscription_plan: string; service_type: string }[];
}

export function useSearchCompanyByPhoneNumber(
    { phoneNumber }: SearchCompanyByPhoneNumberParams,
    options: ClientHookOptions<SearchCompanyByPhoneNumberResponse>
) {
    const { GET } = useVahakHttpClient();

    const searchCompanyByPhoneNumber = () => {
        const queryObj = { p_n: phoneNumber };
        return GET<SearchCompanyByPhoneNumberResponse, unknown>(API.CUSTOMER_PROFILE_DETIALS_BY_PHONE, queryObj);
    };

    return useVahakQuery<SearchCompanyByPhoneNumberResponse, unknown>(
        [QueryNames.searchCompanyByPhoneNumber, phoneNumber],
        searchCompanyByPhoneNumber,
        options
    );
}

export const useSearchCompanyByPhoneNumberMutation = () => {
    const { GET } = useVahakHttpClient();

    function method(params: SearchCompanyByPhoneNumberParams) {
        const { phoneNumber } = params;
        const payload = {
            p_n: phoneNumber
        };
        const urlString = generateQueryString(payload);
        return GET<SearchCompanyByPhoneNumberResponse>(`${API.CUSTOMER_PROFILE_DETIALS_BY_PHONE}${urlString}`);
    }

    return useVahakMutationQuery<SearchCompanyByPhoneNumberResponse, unknown, SearchCompanyByPhoneNumberParams>(
        [QueryNames.searchCompanyByPhoneNumber],
        method
    );
};
